import { Pagination } from '../general';

export enum CreditCardType {
  Visa = 'VISA',
  MasterCard = 'MASTERCARD',
  Dinersclub = 'DINERSCLUB',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Amex = 'AMERICAN_EXPRESS',
  UnionPay = 'UNIONPAY',
  Maestro = 'MAESTRO',
  Mada = 'MADA',
}

export interface CreditCardModel {
  id: number;
  expiryMonth: string;
  expiryYear: string;
  name: string;
  last4: string;
  scheme: CreditCardType;
  bin: string;
  cardHolder: string;
  isDefault: boolean;
  ownerId: number;
  createdAt: string;
  updatedAt: string;
  isMada: boolean;
}

export interface GetCardsResponse {
  data: CreditCardModel[];
  pagination: Pagination;
}
export interface GuestBookingInitializeAddCardRequest {
  firstName: string;
  lastName: string;
  phonenumber: string;
  email: string;
}

export interface InitializeAddCardResponse {
  checkId: string;
  payfort: {
    serviceCommand: string;
    accessCode: string;
    merchantIdentifier: string;
    merchantReference: string;
    currency: string;
    language: string;
    signature: string;
    returnUrl: string;
  };
}

interface AddCardPermanentlyModel {
  save: true;
  name: string;
  isDefault: boolean;
  token: string;
  checkId: string;
  payfortToken: string;
}

interface AddCardOnceModel {
  save: false;
  orderId?: string;
  topUpId?: number;
  token?: string;
  checkId?: string;
}

export type AddCardRequest = AddCardPermanentlyModel | AddCardOnceModel;

export interface AddCardResponse {
  card: CreditCardModel;
}

export interface UpdateCardRequest {
  name: string;
  isDefault: boolean;
}

export interface UpdateCardResponse {
  card: CreditCardModel;
}

export interface GetMadaCardResponse {
  isMada: boolean;
}
export interface GetMadaCardRequest {
  bh6: string;
  bh8: string;
}
